module.exports = __webpack_public_path__ + "img/shusong3.00a44607.jpg";